import { useEffect } from 'react'

/**
 * Stops the page behind a drawer or sheet from scrolling while it is open.
 * On phones an open overlay that still lets the page pan underneath feels
 * broken; on iOS it also lets the address bar collapse mid-gesture.
 *
 * @param {boolean} locked
 */
export function useLockBodyScroll(locked) {
  useEffect(() => {
    if (!locked) return undefined
    const { style } = document.body
    const previous = { overflow: style.overflow, touchAction: style.touchAction }
    style.overflow = 'hidden'
    style.touchAction = 'none'
    return () => {
      style.overflow = previous.overflow
      style.touchAction = previous.touchAction
    }
  }, [locked])
}
